module.exports = __webpack_public_path__ + "static/media/SF-17-A.b19d4366.mp3";